import * as React from "react";
import { connect } from "react-redux";
// components
import AdGroupsList from "./AdGroupsList";
import Band from "../../components/layout/Band";
import BottlerSwitcher from "../../components/switcher/BottlerSwitcher";
import H1 from "../../components/typography/H1";
import Permissions from "../permissions/Permissions";
import Section from "../../components/layout/Section";
// enums
import { RequestTypes } from "../../enums/RequestTypes";
// logging
import { withPageLog } from "../logging/LogComponentChange";
// types
import { IBottler } from "../../types/Bottler";

export interface IBottlerAppUsersProps {
  bottler: IBottler | null;
}

export const BottlerAppUsers: React.StatelessComponent<IBottlerAppUsersProps> = ({ bottler }) => {
  const title: string = "Bottler App Users";

  const bottlerDomains: string[] = [];

  if (bottler) {
    bottler.domains.map(domain => {
      bottlerDomains.push(domain.domain);
    });
  }

  return (
    <div className="groupMembership adGroups">
      <Band>
        <H1>{title}</H1>
      </Band>
      <Section>
        <Permissions title={title}>
          <BottlerSwitcher requestTypeId={RequestTypes.EquipmentRepair} />
          <AdGroupsList
            allowExternalInvite={true}
            bottlerCode={bottler ? [bottler.code] : null}
            bottlerDomains={bottlerDomains}
            bottlerId={bottler ? bottler.id : null}
            showAddUsersMessage={true}
            title={title}
          />
        </Permissions>
      </Section>
    </div>
  );
};

export const mapStateToProps = (state: any) => {
  return {
    bottler: state.bottler.bottler
  };
};

export default connect(mapStateToProps)(withPageLog(BottlerAppUsers));
